module.exports = __webpack_public_path__ + "static/garden-carrots-3782498c57ae0a5d51f6d68582d1ecca.jpg";